module.exports = __webpack_public_path__ + "media/images/download-page-imgs-02-f3dc226c.png";